module.exports = __webpack_public_path__ + "img/Scalable.01376d04.svg";